function _flattenSmarttags(stags, op) {
    if (op === void 0) { op = ''; }
    return stags.reduce(function (acc, stag) {
        (stag.values || []).forEach(function (v) {
            var formattedStag = "".concat(stag.key, ":").concat(op ? "".concat(op, ":") : '').concat(v.key);
            acc.push(encodeURIComponent(formattedStag));
        });
        return acc;
    }, []);
}
var smarttagsToUrl = function (include, exclude) {
    if (include === void 0) { include = []; }
    if (exclude === void 0) { exclude = []; }
    return _flattenSmarttags(include)
        .concat(_flattenSmarttags(exclude, 'not'))
        .join(',');
};
export default smarttagsToUrl;
